<template>
  <div>
    <div class="text-h6 mt-2 mb-3 d-block d-md-none">
      <v-icon color="grey" style="margin-bottom: 3px;">mdi-credit-card-clock-outline</v-icon>
      {{ $t('title') }}
    </div>

    <a-billing-widget></a-billing-widget>
  </div>
</template>

<script>
export default {
  name: 'BillingPage'
}
</script>

<i18n>
{
	"en": {
		"title": "Billing"
	},
	"es": {
		"title": "Facturación"
	},
	"fr": {
		"title": "Facturation"
	},
	"it": {
		"title": "Fatturazione"
	},
	"pt": {
		"title": "Faturação"
	},
	"pl": {
		"title": "Rozliczenia"
	}
}
</i18n>



